import React from 'react';
import { getInitials } from "../../../../helpers/formatting";

export default function Avatar(props) {
    const participant = props && props.isLocalParticipant ? " avatar__local" : "";
    const initials = props && props.userName ? getInitials(props.userName) : "";

    return (<div className={"avatar" + participant}>
                {initials && <span className="avatar--initials">{initials}</span>}
            </div>);


}